// document.addEventListener("DOMContentLoaded", function() {

//   // Navigation section
//   let navigationItems = document.querySelectorAll('.page-navigation__item');
//   let navigationWrapper = document.querySelector('.page-navigation-wrapper');

//     if (navigationItems.length > 0) {
//       navigationItems.forEach((link) => {
//         link.addEventListener('click', (e) => {
//           e.preventDefault();
//           let url = link.getAttribute('data-url');
//           console.log(url)
//           let offset_adjustment = $(window).width() > 768 ? -120 : -80; 
//           $('html, body').animate({
//             // scrollTop: $('#'+url).offset().top - 60
//             scrollTop: $('#'+url).offset().top + offset_adjustment
//           }, 2000)
//         })
//       });
//     }

//     let sectionsSelectors = [];
//     navigationItems.forEach((elem) => {
//       let selector = elem.getAttribute('data-url');
//       sectionsSelectors.push(selector);
//     })

//     document.addEventListener("scroll", (event) => {
//       if(navigationWrapper != null){
//         if(navigationWrapper.getBoundingClientRect().top == 0){
//           document.body.classList.add('navigation-fixed');
//         }else{
//           document.body.classList.remove('navigation-fixed');
//         }
//       }
//       sectionsSelectors.forEach((selector) => {
//         if (selector && document.querySelector('#' + selector) != null) {
//           let x = document.querySelector('#' + selector).getBoundingClientRect().top;
//           if (x < 90) {
//             document.querySelector('.page-navigation .page-navigation__item.active')?.classList.remove('active');
//             document.querySelector(`.page-navigation .page-navigation__item[data-url="${selector}"]`)?.classList.add('active');
//           }
//         }
//       })
//     });



//     if(document.querySelector("#opinew_product_plugin_app") != null){
//       document.querySelector("#opinew_product_plugin_app").click();
//       console.log('CLICK')
//     }
//     let navigationBtns = document.querySelectorAll('.scroll-btn');

//     if (navigationBtns.length > 0) {
//       navigationBtns.forEach((link) => {
//         let url = link.getAttribute('data-url');
//         if(!url.includes('/')){
//          if (url != '' && document.querySelector(url) != null) {
//           link.addEventListener('click', (e) => {
//             e.preventDefault();
//             let selector = e.target.getAttribute('data-url');
//             $('html, body').animate({
//               scrollTop: $(selector).offset().top - 60
//             }, 2000)
//           })
//         }  
//         }
//       });
//     }


// });



   
document.addEventListener("DOMContentLoaded", function() {

  // Navigation section
  let navigationItems = document.querySelectorAll('.page-navigation__item');
  let navigationWrapper = document.querySelector('.page-navigation-wrapper');

    if (navigationItems.length > 0) {
      navigationItems.forEach((link) => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          let url = link.getAttribute('data-url');
          console.log(url)
          let offset_adjustment = $(window).width() > 768 ? -120 : -80; 
          $('html, body').animate({
            // scrollTop: $('#'+url).offset().top - 60
            scrollTop: $('#'+url).offset().top + offset_adjustment
          }, 2000)
        })
      });
    }

    let sectionsSelectors = [];
    navigationItems.forEach((elem) => {
      let selector = elem.getAttribute('data-url');
      sectionsSelectors.push(selector);
    })

    document.addEventListener("scroll", (event) => {
      if(navigationWrapper != null){
        if(navigationWrapper.getBoundingClientRect().top == 0){
          document.body.classList.add('navigation-fixed');
        }else{
          document.body.classList.remove('navigation-fixed');
        }
      }
      sectionsSelectors.forEach((selector) => {
        if (selector && document.querySelector('#' + selector) != null) {
          let x = document.querySelector('#' + selector).getBoundingClientRect().top;
          if (x < 90) {
            document.querySelector('.page-navigation .page-navigation__item.active')?.classList.remove('active');
            document.querySelector(`.page-navigation .page-navigation__item[data-url="${selector}"]`)?.classList.add('active');
          }
        }
      })
    });



    if(document.querySelector("#opinew_product_plugin_app") != null){
      document.querySelector("#opinew_product_plugin_app").click();
      console.log('CLICK')
    }
    let navigationBtns = document.querySelectorAll('.scroll-btn');

    //  if (navigationBtns.length > 0) {
    //   navigationBtns.forEach((link) => {
    //     let url = link.getAttribute('data-url');
    //     if(!url.includes('/')){
    //      if (url != '' && document.querySelector(url) != null) {
    //       link.addEventListener('click', (e) => {
    //         e.preventDefault();
    //         let selector = e.target.getAttribute('data-url');
    //         $('html, body').animate({
    //           scrollTop: $(selector).offset().top - 60
    //         }, 2000)
    //       })
    //     }  
    //     }
    //   });
    // } 

});

//New Codes Test
  let headerHeight = 0;
 
  const regularHeader = document.querySelector('#shopify-section-header-new');
  const recoveryHeader = document.querySelector('.section-container--maze-recovery-header');

 

  console.log('regularHeader', regularHeader);
  console.log('recoveryHeader', recoveryHeader);

  const activeHeader = regularHeader || recoveryHeader;
  

  if (activeHeader) {
    headerHeight = activeHeader.offsetHeight;
    console.log('Header height:', headerHeight);
  } else {
    console.log('No header found');
  }
 //Floating Naviagtion Bar
  const regularFloatingNavigationBar = document.querySelector('.shopify-section.page-navigation-section');
  const recoveryFloatingNavigationBar = document.querySelector('.--rc-floating-navigation');

    const activeFloatingNavigationBar = recoveryFloatingNavigationBar || regularFloatingNavigationBar;
   let floatingNavigationBarHeight = 0;

  if (activeFloatingNavigationBar) {
    floatingNavigationBarHeight = activeFloatingNavigationBar.offsetHeight;
    console.log('Floating Navigation Bar Height:', floatingNavigationBarHeight);
  } else {
    console.log('No Active Floating Navigation Bar found');
  }

  let headergroupHeight = headerHeight + floatingNavigationBarHeight;
  console.log("headergroupHeight",headergroupHeight)
  const navigationButtons = document.querySelectorAll('.scroll-btn');

  window.gotoSection = function (headerHeight, navigationButtons) {
    
    navigationButtons.forEach((button) => {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        console.log("New Function Called", button);
        console.log("headergroupHeight",headerHeight)
        const href = this.getAttribute('href');
        if (!href) return;

        // href = "#section-id" হলে Id কেটে নেওয়া হচ্ছে
        const targetId = href.startsWith('#') ? href.slice(1) : href;
        console.log('targetId',targetId)
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          window.scrollTo({
            top: targetElement.offsetTop - headerHeight - 10,
            behavior: 'smooth',
          });
        }
      });
    });
  };
  
document.addEventListener('DOMContentLoaded', () => {
  
  window.gotoSection(headerHeight, navigationButtons);
});


 